/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Tameem's Portfolio",
  description:
    "Tameem is a junior year lad, pursuing bachelors in computer engineering from UET Peshawar. Tameem hails from Peshawar a city in the KPK state of Pakistan. He is an empath who cares for the entire mankind without bound of religion and terrain. His enchantment towards computers is unprecedented and a curious challenger inside him urges him to explore the vastness of this stream, ultimately making him a curious technology evangelist. From a development perspective, tameem is an open-source contributor. As hardware and software are each other's concomitances so, he loves to design customized hardware and is a good silicon designer. tameem loves to speak regarding technology which surely has leveraged the technical public speaker in him. He iss driven by the will to create an impact and encourage diversity and inclusion in communities. He likes the diversity in tech so, you can find him doing awesome things in different domains of technology ranging from artificial intelligence to DevOps, cloud computing & product management. Excellent guts like public speaking, book reading, and managerial skills have brought up a leader inside him. Being an entrepreneurial folk, he loves to design solutions for real-world problem scenarios and has undergoing startups.",
  og: {
    title: "Tameem Ud Din's Portfolio",
    type: "website",
    url: "https://tameem-623.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Hey, Tameem here! 👋",
  logo_name: "Tameem Ud Din",
  nickname: "",
  subTitle:
    "An ardent tech enthusiast exploring technology's vastness to empower the world with cutting-edge technology.",
  portfolio_repository: "https://drive.google.com/",
  // resumeLink: "https://drive.google.com/",
  // githubProfile: "https://github.com/tameem-623",
};

const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/tameem623/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Github",
    link: "https://github.com/tameem-623",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Medium",
    link: "	https://medium.com/@tameemuddin4",
    fontAwesomeIcon: "fab fa-medium", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Google Developers",
    link: "https://g.dev/tameem623",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github

  },
  {
    name: "Credly",
    link: "https://www.credly.com/users/tameem-uddin",
    fontAwesomeIcon: "fas fa-certificate", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#F40D12"
  },
  {
    name: "Gmail",
    link: "mailto:tameemuddin4@gmail.com",
    fontAwesomeIcon: "fas fa-envelope",
    backgroundColor: "#EA4335", // Reference https://simpleicons.org/?q=gmail
  },
];
// Would be better to change pics here
const skills = {
  data: [
    {
      title: "Computer Systems Engineer | Undergrad | Researcher | Developer",
      fileName: "ComEngStu",
      skills: [
        "⭐ As a junior year lad, I am studying computer engineering at UET Peshawar.",
        "⭐ It is my insatiable curiosity about computers that drives me toward a career in technology & computing.",
      ],
      softwareSkills: [
        {
          skillName: "Hardware",
          fontAwesomeClassname: "ion:hardware-chip-outline",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Technology",
          fontAwesomeClassname: "icon-park:code-laptop",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Computer Engineering",
          fontAwesomeClassname: "icon-park:setting-two",
          style: {
            backgroundColor: "transparent",

          },
        },
        {
          skillName: "Research",
          fontAwesomeClassname: "icon-park:book-open",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Software",
          fontAwesomeClassname: "icon-park:file-code",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "I work on Cutting Edge Technology Domains",
      fileName: "Bleed",

      skills: [
        "⭐ Internet of Things",
        "⭐ Microcontrollers & Embedded Systems",
        "⭐ Arficial Intelligence",
        "⭐ Cloud Computing",
        "⭐ DS & Algo",
      ],
      softwareSkills: [
        {
          skillName: "Coding",
          fontAwesomeClassname: "icon-park:code-laptop",

        },
        {
          skillName: "AI",
          fontAwesomeClassname: "eos-icons:ai",

        },
        {
          skillName: "Health Care",
          fontAwesomeClassname: "icon-park:first-aid-kit",
        },
        {
          skillName: "Education",
          fontAwesomeClassname: "cil:education",
        },
        {
          skillName: "VS Code",
          fontAwesomeClassname: "vscode-icons:file-type-vscode2",
        },
      ],
    },
    {
      title: " Designing Domains | Hardware | Software ",
      fileName: "Hardware",
      skills: [
        "⭐ Hardware and software go hand in hand, therefore, I love designing customized hardware.",
        "⭐ Embedded systems, IoT, Sensor integration, and Microcontrollers.",
        "⭐ Home Automation and Smart Home."
      ],
      softwareSkills: [
        {
          skillName: "Computer Engineering",
          fontAwesomeClassname: "clarity:cog-line",
          style: {
            backgroundColor: "transparent",

          },
        },
        {
          skillName: "Hardware",
          fontAwesomeClassname: "ion:hardware-chip-outline",
        },
        {
          skillName: "Hardware Circuit",
          fontAwesomeClassname: "eos-icons:hardware-circuit",
        },
        {
          skillName: "Microcontrollers",
          fontAwesomeClassname: "logos:arduino",

        },

        {
          skillName: "Silicon",
          fontAwesomeClassname: "bi:laptop",

        },
        {
          skillName: "Home Assistant",
          fontAwesomeClassname: "simple-icons:homeassistant",
        },
      ],
    },
    {
      title: "Open Source Contibution | Cross-Platform Development",
      fileName: "FullStackImg",
      skills: [
        "⭐ It's my passion to be a developer, both hardware and software. Real-life problems can be solved with it!",
        "⭐ Experience working on multiple cloud platforms",
        "⭐ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⭐ Deploying AI models on cloud",
      ],
      softwareSkills: [
        {
          skillName: "C++",
          fontAwesomeClassname: "logos:c-plusplus",

        },
        {
          skillName: "Python",
          fontAwesomeClassname: "vscode-icons:file-type-python",

        },
        {
          skillName: "C",
          fontAwesomeClassname: "logos:c",

        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "logos:google-cloud",

        },
        {
          skillName: "Git",
          fontAwesomeClassname: "akar-icons:github-fill",
          style: {
            backgroundColor: "#FFFFF",
            color: "#000000"
          }
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "logos:microsoft-azure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    // {
    //   title: "Research & Development | Publications",
    //   fileName: "Res",
    //   skills: [
    //     "⭐ I am a technical content writer who writes bite-sized, factual and easy-to-digest publications.",
    //     "⭐ Writing Genre: Technology & Computing",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Writing",
    //       fontAwesomeClassname: "noto:writing-hand",

    //     },
    //     {
    //       skillName: "Research",
    //       fontAwesomeClassname: "simple-icons:researchgate",
    //     },
    //     // {
    //     //   skillName: "Medium Blog",
    //     //   fontAwesomeClassname: "bi:medium",
    //     // },
    //     {
    //       skillName: "Publication",
    //       fontAwesomeClassname: "ant-design:book-outlined"
    //     }
    //   ],
    // },
    {
      title: " IT Support | Mentorship | Technical Talks",
      fileName: "Support",

      skills: [
        "⭐ If you're interested in IT Support & Mentorship, feel free to reach out to me!",
        "⭐ The fact that I love to speak about technology has certainly made me a better technical speaker.",

      ],
      softwareSkills: [
        {
          skillName: "IT",
          fontAwesomeClassname: "icon-park:laptop-computer",
        },
        {
          skillName: "Tech Talks",
          fontAwesomeClassname: "si-glyph:person-talk",
        },
        {
          skillName: "Mentorship",
          fontAwesomeClassname: "icon-park:guide-board",

        },
        {
          skillName: "Support",
          fontAwesomeClassname: "si-glyph:customer-support",

        },

      ],
    },
  ],
};

// Education Page 
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Official Resources",
      iconifyClassname: "bx:bxs-file-doc",
    },
    {
      siteName: "Internet",
      iconifyClassname: "fluent-emoji:globe-with-meridians",
    },
    {
      siteName: "Univeristy Formal Studies",
      iconifyClassname: "fa-solid:university",

    },

    {
      siteName: "Books",
      iconifyClassname: "noto:books",
    },
    {
      siteName: "MOOCs",
      iconifyClassname: "simple-icons:freecodecamp",
    },


    {
      siteName: "YouTube",
      iconifyClassname: "icon-park:youtube",

    },
    // { //SAMPLE
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Engineering & Technology UET, Peshawar",
      subtitle: "B.S Computer Systems Engineering",
      logo_path: "uetplogo.png",
      alt_name: "UET Peshawar",
      duration: "Nov 2020 - Present",
      descriptions: [
        "🎯 Clubs & Societies:",
        "⭐ Member @ Computer Society",
        "⭐ Core Team @ Google Developers Student Club",

        "🎯 Notable Achievements of Alma mater!",
        "⭐ We are immensely proud of our Alma mater, which is one of the most prestigious universities in the country!",
        "⭐ This is a wonderful place for you to thrive, prosper, and shine!",
        "⭐ Washington accord accredited engineering school.",
        "⭐ OBE Outcome-based educational infrastructure (PLOs & CLOs).",
        "⭐ Laboratories with state-of-the-art technology.",
        "⭐ Ranked #7 engineering school nationwide!",
        "⭐ Research & Development oriented studies",
        "⭐ Highly qualified and supportive faculty.",
      ],
      website_link: "https://uetpeshawar.edu.pk",
    },
    {
      title: "Islamia College, Peshawar",
      subtitle: "F.Sc | A-Levels | Pre-Engineering",
      logo_path: "icp_logo.png",
      alt_name: "Islamia College",
      duration: "May 2018 - June 2020",
      descriptions: [
        "🎯 Clubs & Societies:",
        "⭐ Qirat Contests",
        "⭐ Calligraphy",
        "⭐ Talks and Mentorship",

        "🎯 Notable Achievements of Alma mater!",
        "⭐ One of the oldest institutions of higher education in Pakistan.",
        "⭐ Founded in 1913 | More than 100 years of Glory.",
        "⭐ Pakistan's Founder was an honorary member for life.",
        "⭐ Enhance the students' all-round development by revealing their hidden potentials.",
        "⭐ Excellent at Curricular and Co-Curricular activities!",
      ],
      website_link: "https://icp.edu.pk/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Microsoft",
      subtitle: "MTC Azure Fundamentals (AZ-900)",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.credly.com/users/tameem-uddin/badges",
      alt_name: "Microsoft Certification",
      color_code: "#1F70C199",
    },
    {
      title: "Microsoft",
      subtitle: "98-349 MTA Windows® Operating System Fundamentals",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.credly.com/users/tameem-uddin/badges",
      alt_name: "Microsoft Certification",
      color_code: "#0078D4",
    },
    {
      title: "Google Cloud Seekho",
      subtitle: "2 Seasons QwikLabs",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.cloudskillsboost.google/public_profiles/b3a60c5e-754c-41e3-bb9f-3af18eb1d4f4",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Cisco",
      subtitle: "Introduction to IoT",
      logo_path: "cisco_logo.png",
      certificate_link:
        "https://www.credly.com/users/tameem-uddin/badges",
      alt_name: "cisco",
      color_code: "#4285F499",
    },
    {
      title: "HP Life",
      subtitle: "Effective Leadership",
      logo_path: "HP.png",
      certificate_link:
        "https://www.linkedin.com/posts/tameem623_see-my-recent-achievement-activity-6835867029409533952-b-4O?utm_source=linkedin_share&utm_medium=member_desktop_web",
      alt_name: "HP Life",
      color_code: "#4285F499",
    },
    {
      title: "Check out other MOOCs",
      subtitle: "LinkedIn",
      logo_path: "linkedin.svg",
      certificate_link:
        "https://www.linkedin.com/in/tameem623/",
      alt_name: "GDSC Lead", //!
      color_code: "#0078D4",
    },
  ],
};

// Experience Page 
const experience = {
  title: "Experience",
  subtitle: "Work Experiences | Volunteerships | Tech Stack | Achievements | Interpersonal Skillset & Hobbies",
  description:
    "Let's dig deeper!",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experiences",
      experiences: [
        {  // NRPU
          title: "Research & Development Engineer",
          company: "NRPU, Higher Education Commision",
          company_url: "",
          logo_path: "hec.svg",
          duration: "July 2022 - PRESENT",
          location: "Peshawar, KPK",
          description: [
            "I am working on designing and development of a healthcare product. The projects involve developing a orthodic device for augmenting weak neuro-muscular activity for upper and lower limbs of hemiplegic and paraplegics.",
            // "🎯 About Company",
            // " ",
            "🎯 Key Responsibilities",
            "⭐ Technical Writer",
            "⭐ Machine Learning",
            "⭐ Research & Development",
            "⭐ Design and Develop Hardware",
            "⭐ Develop Software"
          ],
          color: "#0879bf",
        },
        {   // FORAGE Data Analyst
          title: "Data Analytics Consultant",
          company: "KPMG Australia",
          company_url: "https://www.theforage.com/virtual-internships/m7W4GMqeT3bh9Nb2c?ref=WoizivBJ7DKq25x47",
          logo_path: "kpmg-blue.png",
          duration: "Aug 2022",
          location: "Virtual | Remote | KPMG Au",
          description: [
            "🎯 About Company",
            "⭐ KPMG is a global network of professional firms providing Audit, Tax and Advisory services.",
            "🎯 Key Responsibilities",
            "⭐ Data Quality Assessment",
            "⭐ Data Insights",
            "⭐ Data Insights and Presentation",
          ],
          color: "#0879bf",
        },
        {    // FORAGE MasterCardIT 
          title: "Security Analyst Consultant",
          company: "Mastercard ",
          company_url: "https://www.theforage.com/virtual-internships/prototype/vcKAB5yYAgvemepGQ/Mastercard-Cybersecurity-Virtual-Experience-Program?ref=WoizivBJ7DKq25x47",
          logo_path: "mastercard.png",
          duration: "Aug 2022",
          location: "Virtual | Remote | Forage",
          description: [
            "I helped to design a phishing email simulation for the Security Awareness team and extracted insights from the simulation result to aware the most vulnerable teams.",
            "🎯 About Company",
            "⭐ They fostering collaboration among business, education, and community leaders to prepare youth in diverse, low-income communities for the future of work and meet employer needs.",
            "🎯 Key Responsibilities",
            "⭐ Design a phishing email simulation",
            "⭐ Interpret phishing simulation results",
          ],
          color: "#0879bf",
        },
        {   // PCS
          title: "Director of Sales and Client Services",
          company: "PCS, Peshawar",
          company_url: "",
          logo_path: "pcs.png",
          duration: "July 2020 - June 2022",
          location: "Peshawar, KPK",
          description: [
            "In addition to being their IT Head, I was also responsible for Quality Control and Product Management. Furthermore, I was responsible for R&D to increase the company's profits by researching new methods and techniques to provide better and more reliable services.",
            "🎯 About Company",
            "⭐ PCS is a private Government registerd Company providing IT equipments sales and services to its valueable customers. ",
            "🎯 Key Responsibilities",
            "⭐ Product Management",
            "⭐ Development",
            "⭐ Sales and Services",
            "⭐ Research & Development",
            "⭐ Quality Control Analyst",
            "🎯Key Achievements:",
            "⭐ Increased Customer Success.",
            "⭐ Increased in Company's Profit.",
          ],
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "Topper | DCSE, UET Peshawar",
          company: "UET, Peshawar",
          company_url: "https://www.uetpeshawar.edu.pk",
          logo_path: "uetplogo.png",
          duration: "",
          location: "UET Peshawar Campus",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Students Club Member",
          company: "DSC, UET Peshawar",
          company_url: "",
          logo_path: "gdsc.png",
          duration: "June 2021 - July 2022",
          location: "UET Peshawar",
          description: [
            "Developer Student Clubs is Google's Campus Ambassador program, empowering the student community to create real-world solutions enhancing peer to peer learning. A well-rounded community of technology evangelists, public speakers, entrepreneurs, community builders, designers, creators, think tanks and developers.",
          ],
          color: "#0C9D58",
        },
        {
          title: "Technical Team",
          company: "Computer Society, UET Peshawar",
          company_url:
            "https://www.facebook.com/computersocietyuetp/",
          logo_path: "cse.png",
          duration: "Oct 2021 - Present",
          location: "On Campus | Virtual",
          description:
            [
              "Computer Society is the leading brand of UET Peshawar. In fact, we are the #1 club on the campus.",

              "Computer Society deals in ranging from",
              "⭐ Departmental gatherings and Official Conferences (DCSE)",
              "⭐ Tech Festivals",
              "⭐ Mega Buzz",
              "⭐ Talks and Conferences",
              "⭐ Hands-on Workshops",
              "⭐ Sports (DCSE Week)",
              "⭐ Tours (Baragali etc)",

            ],
          color: "#1DA1F2",
        },
      ],
    },
    {
      title: "Tech Stack",
      experiences: [
        {
          title: "Core Skills",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: [
            "Computer Systems Engineering, ",
            "Cross-Platform Developer, ",
            "Silicon Designer, ",
            "Program Management, ",
            "Research & Development, ",
            "IT Support & Mentorship, ",
            "Technology Speaker, ",
            "Entrepreneur.",
          ],
          color: "#0071C5",
        },
        {
          title: "Languages",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description:
            "Python, C++, C, MATLAB",
          color: "#0071C5",
        },
        {
          title: "Tech Domains",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: "Artificial Intelligence, Cloud Computing, Internet of Things, DS & Algo, Microcontrollers & Embedded Systems",
          color: "#0071C5",
        },
        {
          title: "Version Control Systems",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: "Git, GitHub, GitLab",
          color: "#0071C5",
        },
        {
          title: "Public Clouds",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: "Microsoft Azure, Google Cloud Platform, Orcale Cloud",
          color: "#0071C5",
        },

        {
          title: "Core CSE Domains",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: "Computer Fundamentals, Programming, Circuits & Systems, Digital Logic Design, CAD, OOP, Operating Systems, Signals & Systems, Electronic Circuits, Data Structures and Algorithms, Probability Methods in Engineering",// Data Communication & Networks, Computer Org. & Architecture, Digital Signal Processing, Engineering Economics, Systems Programming, HCI & Ergonomics, Microprocessors, Database Management System, Digital System Design, Core CS",
          color: "#0071C5",
        },
        {
          title: "Tools",
          company: "Familiarity & Proficiency",
          logo_path: "code.svg",
          description: "MS VSCode, CodeBlocks, Adobe Photoshop, Arduino IDE, MATLAB, Proteus, AutoCAD",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Interpersonal Skillset & Hobbies",
      experiences: [
        {
          title: "Interests & Hobbies",
          company: "",
          logo_path: "feelingProud.svg",
          description:
            "Leadership Qualities, Decision & Policy Maker, Communication Skills, Optimist Problem Solver, Entrepreneurship, Researcher, Developer, Bibliophile",
          color: "#0071C5",
        },
        {
          title: "Languages",
          company: "",
          logo_path: "feelingProud.svg",
          description:
            "Urdu, English, Hindi, Pushto",
          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page 
const projectsHeader = {
  title: "Projects",
  description:
    "It has always been my goal to work on real-world projects where the essence of impact is present. Technologies can be used to solve problems, and projects are the most effective way to go about it. I have done projects in diverse domains.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {};

// Contact Page 
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "v6_366.png",
    description:
      "Please feel free to message me on social media. My response will be within 24 hours. I am available to help you in any way I can!",
  },
  // blogSection: { to remove these two sections , ContactComponents.js file  was also modified
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://ashutoshhathidara.wordpress.com",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle:
      "21 Saddar Lane, Peshawar Cantt. 25000, Khyber Pakhtunkhwa, Pakistan",
    avatar_image_path: "address_image.svg",
    // avatar_image_path: "contactMail.png",
    location_map_link: "https://goo.gl/maps/zfBafi5szsPGgkJZA",
  },
  // phoneSection: {
  //   title: "Phone Number",
  //   subtitle: "+92 ",
  // }, 
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
